<template>
  <b-row class="overflow myModal">
    <div class="mobile">
      <div class="link">
        <button class="bt btn-back" @click="goBack()">
          <font-awesome-icon :icon="['far', 'times']"/>
        </button>
        <h3>Ajouter un collaborateur</h3>
      </div>
      <div class="sep"></div>
    </div>

    <div class="scrollable form__addCollab">
      <div class="col">
        <b-card>
          <b-form-group
            id="input-group-1"
            :label="formContent.formName"
            label-for="collab-name"
          >
            <b-form-input
              id="collab-name"
              v-model="form.title"
              required
              :placeholder="formContent.formNamePlaceholder"
            ></b-form-input>
          </b-form-group>   


          <b-form-group
            id="input-group-1"
            :label="formContent.formFirstname"
            label-for="collab-firstname"
          >
            <b-form-input
              id="collab-firstname"
              v-model="form.firstname"
              required
              :placeholder="formContent.formFirstnamePlaceholder"
            ></b-form-input>
          </b-form-group>   

          <b-form-group
            id="input-group-1"
            :label="formContent.formEmail"
            label-for="collab-email"
          >
            <b-form-input
              id="collab-email"
              v-model="form.email"
              required
              type="email"
              :placeholder="formContent.formEmailPlaceholder"
            ></b-form-input>
          </b-form-group>   
          <Stack></Stack>
          <button class="btn btn-send">Ajouter</button>
        </b-card>
      </div>
    </div>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Stack from '../stack/Stack';


export default {
  name: "FormCollab",
  components: {
    Stack
  },
  props:{
  },
  data() {
    return {
        form: {
          name: '',
          firstname: '',
          email: '',
          checked: []
        },
    }
  },
  computed: {
    ...mapGetters([
        'getGeneral',
    ])
  },
  created (){
    this.formContent = this.getGeneral;
  },  
  methods:{
      onSubmit(evt) {
        evt.preventDefault()
        // alert(JSON.stringify(this.form))
      },
      goBack() {
        this.$router.push({name: "profileCollab"});  
      },       
  }  
}
</script>

